export default __webpack_public_path__ + "static/media/Camping.dde06e53.svg";